// Auto-managed table of contents for the user guide.
// Order here drives sidebar order and prev/next navigation.

import overview from './README.md?raw';
import p00 from './00-easy-start.md?raw';
import p01 from './01-what-is-dreamgraph.md?raw';
import p02 from './02-installation.md?raw';
import p03 from './03-first-instance.md?raw';
import p04 from './04-llm-setup.md?raw';
import p05 from './05-bootstrapping-the-graph.md?raw';
import p06 from './06-vs-code-extension.md?raw';
import p07 from './07-the-explorer.md?raw';
import p08 from './08-dreams-and-cycles.md?raw';
import p09 from './09-curating-the-graph.md?raw';
import p10 from './10-daily-workflow.md?raw';
import p11 from './11-multi-repo.md?raw';
import p12 from './12-troubleshooting-faq.md?raw';
import p13 from './13-glossary.md?raw';
import p14 from './14-adaptive-future-engine.md?raw';
import p15 from './15-architect-beta.md?raw';
import p16 from './16-ashoka-upgrade.md?raw';
import p17 from './17-computer-use.md?raw';
import architectTasks from './architect-for-dummies.md?raw';

export interface GuideEntry {
  slug: string;
  title: string;
  group: 'Start here' | 'Read in order' | 'Topical reference';
  body: string;
}

export const guideEntries: GuideEntry[] = [
  { slug: 'computer-use', title: 'Computer Use: browser setup', group: 'Start here', body: p17 },
  { slug: 'ashoka-upgrade', title: 'Ashoka upgrade and limits', group: 'Start here', body: p16 },
  { slug: 'overview', title: 'Overview', group: 'Start here', body: overview },
  { slug: 'easy-start', title: 'Easy Start', group: 'Start here', body: p00 },
  { slug: 'what-is-dreamgraph', title: '1. What is DreamGraph?', group: 'Read in order', body: p01 },
  { slug: 'installation', title: '2. Installation', group: 'Read in order', body: p02 },
  { slug: 'first-instance', title: '3. Your first instance', group: 'Read in order', body: p03 },
  { slug: 'llm-setup', title: '4. LLM setup', group: 'Read in order', body: p04 },
  { slug: 'bootstrapping-the-graph', title: '5. Bootstrapping the graph', group: 'Read in order', body: p05 },
  { slug: 'vs-code-extension', title: '6. VS Code extension', group: 'Read in order', body: p06 },
  { slug: 'the-explorer', title: '7. The Explorer', group: 'Read in order', body: p07 },
  { slug: 'dreams-and-cycles', title: '8. Dreams and cycles', group: 'Read in order', body: p08 },
  { slug: 'curating-the-graph', title: '9. Curating the graph', group: 'Read in order', body: p09 },
  { slug: 'daily-workflow', title: '10. Daily workflow', group: 'Read in order', body: p10 },
  { slug: 'multi-repo', title: '11. Multi-repo setups', group: 'Topical reference', body: p11 },
  { slug: 'troubleshooting-faq', title: '12. Troubleshooting & FAQ', group: 'Topical reference', body: p12 },
  { slug: 'glossary', title: '13. Glossary', group: 'Topical reference', body: p13 },
  { slug: 'adaptive-future-engine', title: '14. Adaptive Future Engine', group: 'Topical reference', body: p14 },
  { slug: 'architect', title: '15. Architect', group: 'Start here', body: p15 },
  { slug: 'architect-for-dummies', title: 'Architect task guide', group: 'Start here', body: architectTasks },
];

export const guideBySlug = new Map(guideEntries.map((e) => [e.slug, e]));
